export default __webpack_public_path__ + "static/media/00.ff3daf03.jpg";